import BoxBlock from '../../containers/box/block';
import React from 'react';
import ArticleTabProps from './props';
import { flattenChildren } from '../..';

const RootContainer = (props: ArticleTabProps) => flattenChildren(props.content).length ? <BoxBlock {...props}/> : null;

export default RootContainer;
